/**
 * TextReveal — Titolo che appare lettera per lettera (stagger).
 * Usare quando la card diventa active per evitare animazione continua.
 */

import { motion } from "framer-motion";

type TextRevealProps = {
  text: string;
  /** Animate only when true (e.g. when step is active) */
  animate?: boolean;
  /** Duration per character */
  charDuration?: number;
  /** Delay between characters */
  charDelay?: number;
};

export function TextReveal({
  text,
  animate = true,
  charDuration = 0.10,
  charDelay = 0.004,
}: TextRevealProps) {
  const chars = Array.from(text);

  return (
    <span className="inline-block">
      {chars.map((ch, i) => (
        <motion.span
          key={i}
          initial={{ opacity: 0, y: 6 }}
          animate={animate ? { opacity: 1, y: 0 } : { opacity: 0, y: 6 }}
          transition={{
            duration: charDuration,
            delay: animate ? i * charDelay : 0,
          }}
          className="inline-block"
        >
          {ch === " " ? "\u00A0" : ch}
        </motion.span>
      ))}
    </span>
  );
}
